var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newIntegrationSettings(data) {
    var instance = {
        __type: "IntegrationSettings:#DecisionsFramework.ServiceLayer.Services.Portal",
        WarningText: null,
        SecurityOption: 0 /* WebClientSecurityOptions.Default */,
        ThreadPoolSettings: null,
        UseAsymmetricKey: false,
        JwtSecretKey: null,
        JwtPublicKey: null,
        DisableGithub: false,
        Id: null,
        Hidden: false,
        AdministratorViewOnly: false,
        EntityFolderID: null,
        HistoryFolderID: null,
        AllTagsData: null,
        State: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        CreatedBy: null,
        ModifiedBy: null,
        Archived: false,
        ArchivedBy: null,
        ArchivedDate: new Date('0001-01-01T00:00:00Z'),
        Deleted: false,
        DeletedBy: null,
        DeletedOn: new Date('0001-01-01T00:00:00Z'),
        CustomLongDescription: null,
        CustomShortDescription: null
    };
    return __assign(__assign({}, instance), data);
}
export function isIntegrationSettings(object) {
    return object.__type === "IntegrationSettings:#DecisionsFramework.ServiceLayer.Services.Portal";
}
